import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { ReactQueryConfigProvider } from 'react-query'
import { ThemeProvider } from 'emotion-theming'

import { AuthProvider } from 'context/auth-context'
import { AsyncErrorHandler } from 'components/async-errors-handler'
import { theme } from 'theme'
import GlobalStyle from 'theme/global-style'
import { FullPageRenderingErrorFallback } from 'components/full-page-error-fallback'
import { IconContext } from "react-icons"
import { ToastContainer, Slide } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { Grommet } from 'grommet'
import ponyTheme from 'theme/pony-theme'
import { AsyncIntlProvider } from 'context/async-intl-context'
import { queryConfig } from 'utils/react-query-config'
import { ApplicationInsightsTools } from 'components/application-insights-tools'

function AppProviders({ children }) {
    return (
        <React.Fragment>
            <ApplicationInsightsTools
                instrumentationKey={window._env_.REACT_APP_AI_INSTRUMENTATION_KEY}
            />
            <AsyncIntlProvider>
                <ThemeProvider theme={{ ...theme, ...ponyTheme }}>
                    <IconContext.Provider value={{ color: 'gray', className: 'global-class-name' }}>
                        {/* todo nikita Переопредилть цвета в тостере на те, которые есть в теме */}
                        <ToastContainer
                            position='top-right'
                            autoClose={2000}
                            hideProgressBar={true}
                            newestOnTop={true}
                            closeOnClick
                            pauseOnHover
                            transition={Slide}
                        />
                        <ReactQueryConfigProvider config={queryConfig}>
                            <AsyncErrorHandler FallbackComponent={FullPageRenderingErrorFallback}>
                                <Grommet theme={ponyTheme}>
                                    <Router>
                                        <AuthProvider>{children}</AuthProvider>
                                    </Router>
                                </Grommet>
                            </AsyncErrorHandler>
                        </ReactQueryConfigProvider>
                    </IconContext.Provider>
                </ThemeProvider>
            </AsyncIntlProvider>
        </React.Fragment>
    )
}

export {
    AppProviders
}

